<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-input v-model="query.orderType.name" clearable placeholder="business.label.orderType" size="small" type="search" @search-click="refresh"/>
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
      :height="height"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :cell-render="{name:'VxeInput',props:{readonly:true},events:{click:({row})=>openModal('orderTypeModal',{available:true},row)}}" field="orderType.name" title="business.label.orderType"/>
      <vxe-column :cell-render="{name:'VxeSelect',options:inventoryStates}" field="inventoryState" title="business.label.inventoryState"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="defaults" title="business.label.defaults" width="70"/>
      <vxe-column :cell-render="{name:'VxeInput',props:{readonly:true},events:{click:({row})=>openModal('warehouseModal',{available:true},row)}}" field="warehouse.name" title="business.label.warehouse"/>
      <vxe-column :cell-render="{name:'VxeInput',props:{readonly:true},events:{click:({row})=>openModal('storerModal',{available:true},row)}}" field="storer.name" title="business.label.storer"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <order-type-modal ref="orderTypeModal" @change="(e,row)=>onOrderTypeChange(row,e[0])"/>
    <warehouse-modal ref="warehouseModal" @change="(e,row)=>onWarehouseChange(row,e[0])"/>
    <storer-modal ref="storerModal" @change="(e,row)=>onStorerChange(row,e[0])"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { findAll, findEnum, saveAll } from '@/api/Api'
import { ENTERPRISE, SCREEN_HEIGHT } from '@/store/mutation-types'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import WarehouseModal from '@/views/modal/WarehouseModal.vue'
import StorerModal from '@/views/modal/StorerModal.vue'
import { OrderType } from '@/api/dto/common/OrderType'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { Storer } from '@/api/dto/common/Storer'
import { InventoryStateConfig } from '@/api/dto/config/InventoryStateConfig'

export default {
  name: 'InventoryStateConfig',
  components: {
    OrderTypeModal,
    WarehouseModal,
    StorerModal
  },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      loading: false,
      data: [],
      query: new InventoryStateConfig(),
      page: 1,
      size: 20,
      contentSize: 0,
      inventoryStates: [],
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.815),
      editRules: {
        'orderType.name': [
          { required: true, type: 'string', message: '订单类型不能为空' }
        ],
        inventoryState: [
          { required: true, type: 'number', message: '库存状态不能为空' }
        ]
      }
    }
  },
  created() {
    findEnum('InventoryState').then(res => {
      if (res.success) {
        this.inventoryStates = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('inventoryStateConfigFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new InventoryStateConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    openModal(modal, args, e) {
      this.$refs[modal].open(args, e)
    },
    onOrderTypeChange(row, record) {
      row.orderType = new OrderType(record)
    },
    onWarehouseChange(row, record) {
      row.warehouse = new Warehouse(record)
    },
    onStorerChange(row, record) {
      row.storer = new Storer(record)
    },
    add() {
      this.data.push(new InventoryStateConfig())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.enterprise = this.enterprise
          return item.toJSONObject()
        })
        saveAll('inventoryStateConfigPersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>